import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostLoading, EGetPostActionType } from './types';

export const getPostLoading: () => TGetPostLoading = actionGenerator<EGetPostActionType.Loading>(
  EGetPostActionType.Loading,
);
